<template>
  <div class="hidden-print sidebarnew" v-if="isAuth">
    <div id="main_sidebar_menu" class="sidebar-overlay" v-if="false">
      <div class="sidebar-menu sidebar-menu-top">
        <b-nav>
          <li
            v-for="(item, index) in topMenuItems"
            :key="item.id"
            class="nav-item"
          >
            <a
              v-if="
                item.routeParams.name === 'ApplicantListView' &&
                isCompanyAdvanceOrPro &&
                isCompanyPassive
              "
              v-authenticate="{ status: 'hide', method: item.authenticate }"
              class="nav-link disable-nav-link"
              @click="onExpiredNavButtonClick(resource[item.text])"
            >
              <span class="nav-item-icon">
                <i :class="item.iconClass" />
              </span>
              <span class="nav-item-text sm" v-html="resource[item.text]" />
            </a>

            <router-link
              v-else-if="
                index === 0 &&
                !currentUser.nonAuthorizedPermissions.includes(
                  'job.publishnewjob',
                )
              "
              :id="item.id"
              v-authenticate="{ status: ' hide', method: item.authenticate }"
              :to="
                isConsultantFirm ? item.routeParams : { name: 'JobCreateView' }
              "
              class="nav-link"
            >
              <div class="nav-item-content">
                <span class="nav-item-icon">
                  <i :class="item.iconClass" />
                </span>
                <span class="nav-item-text sm" v-html="resource[item.text]" />
              </div>
            </router-link>

            <router-link
              v-else-if="
                index !== 0 &&
                item.routeParams.name !== 'ApplicantListView' &&
                item.routeParams.name !== 'ReportView' &&
                item.routeParams.name !== 'HrVenueView'
              "
              :id="item.id"
              v-authenticate="{ status: 'hide', method: item.authenticate }"
              :class="[
                'nav-link',
                { 'router-link-active': item.meta === $route.meta.className },
              ]"
              :to="
                isCompanyPassive &&
                item.routeParams.name === 'ActiveJobListView'
                  ? { name: 'PassiveJobListView' }
                  : item.routeParams
              "
            >
              <span class="nav-item-icon" @click="onDefaultNavButtonClick">
                <i :class="item.iconClass">{{ item.icon }}</i>
              </span>
              <span class="nav-item-text sm" v-html="resource[item.text]" />
            </router-link>
            <router-link
              v-else-if="showHrVenue && item.routeParams.name === 'HrVenueView'"
              :id="item.id"
              :class="[
                'nav-link',
                { 'router-link-active': item.meta === $route.meta.className },
              ]"
              :to="item.routeParams"
            >
              <span class="nav-item-icon">
                <i :class="item.iconClass"> </i>
              </span>
              <span class="nav-item-text sm" v-html="resource[item.text]" />
            </router-link>
            <router-link
              v-else-if="
                (item.routeParams.name === 'ApplicantListView' &&
                  isCompanyAdvanceOrPro) ||
                (item.routeParams.name === 'ReportView' &&
                  currentUser.hasHrCheckUpRight)
              "
              :id="item.id"
              v-authenticate="{ status: 'hide', method: item.authenticate }"
              :class="[
                'nav-link',
                { 'router-link-active': item.meta === $route.meta.className },
              ]"
              :to="
                isCompanyPassive &&
                item.routeParams.name === 'ActiveJobListView'
                  ? { name: 'PassiveJobListView' }
                  : item.routeParams
              "
            >
              <span class="nav-item-icon" @click="onDefaultNavButtonClick">
                <i :class="item.iconClass">
                  {{ item.icon }}
                </i>
              </span>
              <span class="nav-item-text sm" v-html="resource[item.text]" />
            </router-link>
          </li>
          <li
            v-for="item in bottomMenuItems"
            :id="item.id"
            :key="item.id"
            class="nav-item"
          >
            <router-link
              :class="[
                'nav-link',
                { 'router-link-active': item.meta === $route.meta.className },
              ]"
              :to="item.routeParams"
            >
              <span class="nav-item-icon">
                <i :class="item.iconClass" />
              </span>
              <span class="nav-item-text sm" v-html="resource[item.text]" />
            </router-link>
          </li>
        </b-nav>
      </div>
    </div>
    <div v-else id="main_sidebar_menu" class="sidebarnew-overlay">
      <div class="sidebar-menu sidebar-menu-top">
        <side-bar-header />
        <side-bar-menu />
        <side-bar-footer />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import AccountService from '@/services/account';

export default {
  name: 'MainSidebarMenu',

  components: {
    SideBarHeader: () => import('./SideBarHeader.vue'),
    SideBarMenu: () => import('./SideBarMenu.vue'),
    SideBarFooter: () => import('./SideBarFooter.vue'),
  },

  data() {
    return {
      avtMenuAdd: false,
      topMenuItems: [
        {
          text: 'view.JobCreate',
          iconClass: 'icon-add2 ext-color-white',
          id: 'nav_create_job',
          authenticate: 'job.publishnewjob',
          routeParams: { name: 'SelectionAdType' },
        },
        {
          text: 'view.JobList',
          iconClass: 'icon-list2',
          id: 'nav_job_list',
          meta: 'page-job-list',
          authenticate: 'job.list',
          routeParams: { name: 'ActiveJobListView' },
        },
        {
          text: 'view.AllApplicants',
          iconClass: 'icon-all-applicants',
          id: 'nav_all_applicant_list',
          meta: 'page-job-details',
          authenticate: 'job.list',
          routeParams: {
            name: 'ApplicantListView',
            query: { page: 1, jobId: 0 },
          },
        },
        {
          text: 'view.CandidateListOfList',
          iconClass: 'icon-applicant-list',
          id: 'nav_candidate_list',
          authenticate: 'candidatelist.view',
          routeParams: {
            name: 'CandidateListOfListView',
            query: { page: 1 },
          },
        },
        {
          text: 'view.HrVenueView',
          iconClass: 'icon-hrvenue',
          id: 'hrvenue_list',
          meta: 'page-hr-venue',
          // authenticate: 'report.view',
          routeParams: {
            name: 'HrVenueView',
          },
        },
        {
          text: 'view.ReportView',
          iconClass: 'material-icons',
          icon: 'bar_chart',
          id: 'nav_report',
          meta: 'page-my-report',
          authenticate: 'report.view',
          routeParams: {
            name: 'ReportView',
            params: { tabName: 'report' },
          },
        },
      ],
      bottomMenuItems: [],
      ResumePoolRight: false,
    };
  },

  computed: {
    ...mapGetters(['getCompanyClosingDate']),

    defaultExpiredText() {
      return this.resource['jobList.PassiveCompanyAlert.Text'];
    },

    showHrVenue() {
      return !this.isCompanyWelcome && !this.isCompanyPassive;
    },

    isAuth() {
      return AccountService.checkAuth();
    },
  },

  mounted() {
    this.setExpireAlertText(this.defaultExpiredText);
  },
  created() {},
  methods: {
    ...mapMutations(['setExpireAlertText']),
    onExpiredNavButtonClick(navButtonName) {
      const text = this.resource['jobList.PassiveCompanyMenuClick.Text'].data(
        navButtonName,
      );
      this.setExpireAlertText(text);
    },
    onDefaultNavButtonClick() {
      this.setExpireAlertText(this.defaultExpiredText);
    },
  },
};
</script>

<style lang="scss">
@import "~@/style/design-kit/_variable.scss";

.disable-nav-link {
  cursor: pointer;
}

.sidebarnew {
background-color: #353535;
}
</style>
